/* eslint-disable no-useless-escape */
import skyCardValidator from "card-validator"

export function creditCardNormalizer(value) {
  let normalized = value.match(/[0-9]*/g).join("")
  const recognizedCard = skyCardValidator.number(normalized).card

  if (recognizedCard) {
    const { gaps } = recognizedCard
    gaps.reverse().forEach(gap => {
      // inserting space in reverse order to keep correct indexes
      normalized = `${normalized.substring(0, gap)} ${normalized.substring(gap)}`
    })
  } else if (normalized.length > 0) {
    // default formatting for not recognized cards
    normalized = normalized.match(new RegExp(".{1,4}", "g")).join(" ")
  }
  return normalized.trim()
}

export function passengerNameNormalizer(value) {
  return value.match(/[^1234567890`~!\?@#\$%\^&,:;\*_=\+\|\(\)<>«»\[\]\{}\\\/’”№]*/g).join("") // eslint-disable-line no-useless-escape
}

export function numberNormalizer(value) {
  return value.match(/[0-9]*/g).join("")
}

// only checks for allowed characters in floats
export function decimalNumberNormalizer(value) {
  return value.match(/[0-9,.]*/g).join("")
}

export function travelDocumentNormalizer(value: string) {
  return value.replace(/[^a-z0-9]/gi, "")
}

export function latinCharsNormalizer(value) {
  return value.match(/[\w\d]*/g).join("")
}

export function emailNormalizer(value) {
  return value.replace(/\s/g, "")
}

export function phoneNormalizer(value) {
  // + ( ) space - digit
  return value.match(/[\+\(\) \-\d]*/g).join("") // eslint-disable-line no-useless-escape
}

export function promoCodeNormalizer(value) {
  return value.match(/[0-9a-zA-Z]*/g).join("")
}

export function escapeSpecialCharsNormalizer(value) {
  return value.match(/[0-9]*[a-z]*[0-9]*[a-z]*[0-9]*/g).join("")
}

// Normalize inputs maxLength
export const maxLengthNormalizer = maxLength => value => value.substring(0, maxLength)

export function normalizeValue(val, normalize) {
  if (normalize) {
    if (Array.isArray(normalize)) {
      // Pass through all normalizers
      return normalize.reduce((value, normalizer) => (normalizer ? normalizer(value) : value), val)
    }
    // Pass through one normalizer
    return normalize(val)
  }
  // Return as is
  return val
}
